export enum Roles {
    ADMIN = 'Admin',
    OWNER = 'RestaurantOwner',
    USER = 'MobileUser',
    EMPLOYEE = 'RestaurantEmployee',
}

export enum MenuType {
    Daily,
    Standard,
    Special,
    Catalog,
    MultiCourse,
}

export enum OrderStatus {
    Cart,
    Order,
    InProgress,
    Ready,
    Delivery,
    Closed,
    Cancelled,
}

export enum OrderItemStatus {
    Cart = 'CART',
    Order = 'ORDER',
    ReadyToPrepare = 'READYTOPREPARE',
    InProgress = 'INPROGRESS',
    Ready = 'READY',
    Delivered = 'DELIVERED',
    Closed = 'CLOSED',
    Cancelled = 'CANCELLED',
    Storno = 'STORNO',
}

export enum Positions {
    WAITER = 'Waiter',
    BARMAN = 'Barman',
    COOK = 'Cook',
    MANAGER = 'Manager',
}

export enum PaymentMethod {
    None,
    Online,
    Card,
    Cash,
    PayLater,
}

export enum OrderUpdateStatus {
    UpdateReadyDishes,
    UpdateOrdersCount,
    ShowOverduedOrders,
}

export enum OrderServices {
    HomeDelivery = 'HomeDelivery',
    DineIn = 'DineIn',
    TakeAway = 'TakeAway',
    TakeOut = 'TakeOut',
}

export enum TaxType {
    None = 'None',
    StandardRate = 'StandardRate',
    ReducedRate = 'ReducedRate',
    SpecialRateForAccommodation = 'SpecialRateForAccommodation',
    NoVAT = 'NoVAT',
}

export enum SpicinessLevels {
    None,
    MildlySpicy,
    MediumSpicy,
    FieryHot,
}

export enum Diets {
    None,
    Vegetarian,
    Vegan,
}

export enum DietaryLaws {
    None,
    Halal,
    Kosher,
}

export enum PaymentStatus {
    Open,
    Success,
    Failed,
    Cancelled,
}

export enum PrintType {
    SingleItem,
    WholeOrder,
    AllInWorkArea,
    AllInStatus,
}

export enum CookColumnSort {
    None,
    Order,
    Name,
    QR,
    Course,
}

export enum TermsContentType {
    None,
    Link,
    Html,
}

export enum PrinterServerStatus {
    Pending,
    Active,
    Disabled,
}
